import { Card, message, Modal, Table, Typography } from 'antd';
import { buttonMessages, requestform } from '../../messages';
import React, { useEffect, useRef, useState } from 'react';
import { useReactToPrint } from 'react-to-print';
import { useGetQaIntegrationDetail } from '../../hooks';
import {
  CompleteQaIntegrationRequestDto,
  CriteriaDataDetail,
  QaDetail,
  QaDetailMainInfor,
  TicketDetail,
  UpdateQaIntegrationRequestDto
} from '../../types';
import QaIntegrationDetailInformation from './QaIntegrationDetailInformation';
import RequestStatusBar from 'components/request-form/RequestStatusBar';
import { ColumnsType } from 'antd/es/table';
import TextArea from 'antd/es/input/TextArea';
import {
  useGetUserProfileQuery,
  usePostQaIntegrationCompleteMutation,
  usePostQaIntegrationUpdateMutation
} from '../../services';
import { GetTicketDetail } from '../../hooks/request-form';
import defaultTicketDetail from '../../types/dto/request-form/request-form.dto';

type QaIntegrationDetailProps = {
  evaluationId: number;
  refreshAfterAction: () => void;
  ticketId: number;
};

const QaIntegrationDetail: React.FC<QaIntegrationDetailProps> = ({ evaluationId, refreshAfterAction, ticketId }) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const reactToPrintFn = useReactToPrint({ contentRef });

  const [createData, setCreateData] = useState<QaDetailMainInfor>(Default_QaDetailMainInfor);
  const [qaIntegrationDetail, setQaIntegrationDetail] = useState<QaDetail>(Default_QaIntegrationDetail);
  console.log(qaIntegrationDetail);
  const { data, isLoading } = useGetQaIntegrationDetail(evaluationId);

  const [detail, setDetail] = useState<TicketDetail>(defaultTicketDetail);
  const { requestDetail } = GetTicketDetail(ticketId);
  useEffect(() => {
    setDetail(requestDetail);
  }, [requestDetail]);

  const { data: profileRes } = useGetUserProfileQuery(undefined, {
    refetchOnMountOrArgChange: true
  });
  const agent = profileRes?.data.username || '';

  useEffect(() => {
    if (data) {
      setCreateData({
        id: data.id || 0,
        evaluator: data.evaluator || '',
        evaluationDate: data.evaluationDate || '',
        evaluationStatus: data.evaluationStatus || 0,
        recordingLink: data.recordingLink || '',
        videoLink: data.videoLink || '',
        evaluationStatusDescription: data.evaluationStatusDescription || '',
        completionDate: data.completionDate || '',
        evaluationContent: data.evaluationContent || '',
        feedbackContent: data.feedbackContent || '',
        totalScore: data.totalScore || 0,
        criteriaVersion: data.criteriaVersion || 0,
        totalDeductedScore: data.totalDeductedScore || 0
      });

      setQaIntegrationDetail(data);
    }
  }, [data]);

  const columns: ColumnsType<CriteriaDataDetail> = [
    {
      title: 'LOẠI ĐÁNH GIÁ',
      dataIndex: 'criteriaName',
      key: 'criteriaName',
      width: '83%',
      render: (text: string, record: CriteriaDataDetail) => {
        const indentLevel = record.level || 0;
        const tabStyle = { paddingLeft: `${indentLevel * 30}px` };

        return (
          <div style={tabStyle} className='whitespace-pre-wrap text-sm font-medium text-[#141414]'>
            {text}
          </div>
        );
      }
    },
    {
      title: 'MỨC ĐÁNH GIÁ',
      dataIndex: 'score',
      key: 'score',
      width: '17%',
      render: (text: string, record: CriteriaDataDetail) => {
        const criterionId = record?.id;
        const deductedScore = qaIntegrationDetail?.detailedEvaluationInfo?.[criterionId];

        if (deductedScore !== undefined) {
          if (deductedScore !== 0)
            return (
              <Typography.Text className='text-[14px]/[18px] font-semibold italic text-[#D1131D]'>{`Trừ ${deductedScore} điểm`}</Typography.Text>
            );
          return <Typography.Text className='text-[14px]/[18px] italic text-[#868D97]'>Không trừ</Typography.Text>;
        }
        return null;
      }
    }
  ];
  const qa_integration_status = {
    0: 'qa_integration_evaluating',
    1: 'qa_integration_waiting_confirm',
    2: 'qa_integration_responded',
    3: 'qa_integration_confirmed',
    4: 'qa_integration_auto_confirmed'
  } as const;

  const [fbOpen, setFbOpen] = useState(false);
  const openFeedback = () => setFbOpen(true);
  const closeFeedback = () => setFbOpen(false);

  const [processingContent, setProcessingContent] = useState<string>('');
  const [updateIntegration] = usePostQaIntegrationUpdateMutation();
  const updateIntegrationAction = () => {
    const requestData: UpdateQaIntegrationRequestDto = {
      evaluationId: String(evaluationId),
      responseContent: processingContent
    };

    Modal.confirm({
      title: 'Phản hồi đánh giá',
      content: 'Xác nhận phản hồi đánh giá',
      okText: 'Xác nhận',
      cancelText: 'Hủy',
      onOk() {
        updateIntegration(requestData)
          .unwrap()
          .then((res) => {
            refreshAfterAction();
            message.success('Phản hồi đánh giá thành công');
          });
      }
    });
  };

  const [completeQa] = usePostQaIntegrationCompleteMutation();
  const completeQaAction = () => {
    const requestData: CompleteQaIntegrationRequestDto = {
      evaluationId: String(evaluationId),
      responseContent: processingContent,
      agent
    };

    Modal.confirm({
      width: 800,
      title: 'Xác nhận đánh giá',
      content: 'Xác nhận nội dung đánh giá',
      okText: 'Xác nhận',
      cancelText: 'Hủy',
      onOk() {
        completeQa(requestData)
          .unwrap()
          .then((res) => {
            refreshAfterAction();
            message.success('Xác nhận đánh giá thành công');
          });
      }
    });
  };

  return (
    <Card
      title={
        <Typography.Text className='w-full text-center text-[16px]/[22px] font-semibold'>
          {requestform.requestTicket} {evaluationId}
        </Typography.Text>
      }
      className='request-form-detail-card text-center'
    >
      <div className='flex w-full text-left'>
        <div className='w-[350px]'>
          <QaIntegrationDetailInformation
            detail={detail}
            evaluationId={evaluationId}
            qaIntegrationCreateMainInformationDto={createData}
          />
        </div>

        <section className='flex flex-col'>
          <section className='h-[80vh] w-[870px] overflow-y-auto overflow-x-hidden p-6'>
            <div className={'h-full'}>
              <section className='flex items-center justify-end'>
                {/*<button onClick={() => reactToPrintFn()} className='flex items-center space-x-2'>*/}
                {/*  <PrinterIcon />*/}
                {/*  <Typography.Text className='text-[16px]/[20px] text-[#1564E8]'>*/}
                {/*    {requestform.printTicket}*/}
                {/*  </Typography.Text>*/}
                {/*</button>*/}
              </section>

              <section className='pb-6'>
                <RequestStatusBar
                  status={qa_integration_status[qaIntegrationDetail?.evaluationStatus as 0 | 1 | 2 | 3 | 4]}
                />
              </section>
              <Table
                loading={isLoading}
                columns={columns}
                dataSource={qaIntegrationDetail.criteriaData}
                rowKey={(record) => record.id}
                pagination={false}
                className={'overflow-y-auto'}
              />

              {/*{qaIntegrationDetail?.evaluationStatus !== 3 && qaIntegrationDetail?.evaluationStatus !== 4 && (*/}
              <section className='items-center justify-between pb-2 pt-6 text-left'>
                <Typography.Text className={'text-[14px]/[18px] font-semibold text-[#141414]'}>
                  Nội dung yêu cầu
                </Typography.Text>
              </section>
              <TextArea
                value={detail?.content || 'Không có nội dung yêu cầu'}
                disabled
                className='no-resize! my-0 rounded-lg bg-[#F7F8F6]'
                autoSize={{ minRows: 5, maxRows: 10 }}
              />

              <section className='items-center justify-between pb-2 pt-6 text-left'>
                <Typography.Text className={'text-[14px]/[18px] font-semibold text-[#141414]'}>
                  Nội dung đánh giá
                </Typography.Text>
              </section>
              <TextArea
                value={qaIntegrationDetail?.evaluationContent || 'Không có nội dung đánh giá'}
                disabled
                className='no-resize! my-0 rounded-lg bg-[#F7F8F6]'
                autoSize={{ minRows: 5, maxRows: 10 }}
              />

              <section className='items-center justify-between pb-2 pt-6 text-left'>
                <Typography.Text className={'text-[14px]/[18px] font-semibold text-[#141414]'}>
                  Nội dung phản hồi
                </Typography.Text>
              </section>
              <TextArea
                value={qaIntegrationDetail?.feedbackContent || 'Không có nội dung phản hồi'}
                disabled
                className='no-resize! rounded-lg bg-[#F7F8F6]'
                autoSize={{ minRows: 5, maxRows: 10 }}
              />
              {/*)}*/}
            </div>
          </section>

          <section className='flex h-[4rem] items-center justify-between space-x-4 border-t-2 p-6 text-left'>
            <div>
              {qaIntegrationDetail?.evaluationStatus !== 3 && qaIntegrationDetail?.evaluationStatus !== 4 && (
                <div className={'flex gap-3'}>
                  <button
                    onClick={() => completeQaAction()}
                    className='rounded-lg bg-[#1564E8] px-6 py-[10px] text-[16px]/[20px] font-semibold text-[#FFFFFF]'
                  >
                    {buttonMessages.confirm}
                  </button>
                  <button
                    onClick={() => openFeedback()}
                    className='rounded-lg bg-[#D1131D] px-6 py-[10px] text-[16px]/[20px] font-semibold text-[#FFFFFF]'
                  >
                    {buttonMessages.feedback}
                  </button>
                </div>
              )}
            </div>

            <div className={'space-y-2 text-right'}>
              <div className={'flex justify-end gap-8 text-[#D1131D]'}>
                <div>
                  <Typography.Text>Tổng điểm trừ:</Typography.Text>
                </div>
                <div className={'max-w-[40px]'}>
                  {Object.values(qaIntegrationDetail.detailedEvaluationInfo).reduce((sum, score) => sum + score, 0)}
                </div>
              </div>
              <div className={'flex justify-end gap-6 text-[#181818]'}>
                <div>
                  <Typography.Text className={'font-semibold'}>
                    Tổng điểm{' '}
                    <Typography.Text className={'font-normal italic text-[#DEE2E6]'}>
                      (10 - tổng điểm trừ):
                    </Typography.Text>
                  </Typography.Text>
                </div>
                <div className={'max-w-[40px] font-semibold'}>{qaIntegrationDetail.totalScore || ''}</div>
              </div>
            </div>
          </section>
        </section>

        <Modal open={fbOpen} onCancel={() => setFbOpen(false)} footer={null} width={800} centered>
          <section className='items-center justify-between pb-2 pt-6 text-left'>
            <Typography.Text className={'text-[14px]/[18px] font-semibold text-[#141414]'}>
              Nội dung phản hồi
            </Typography.Text>
          </section>
          <TextArea
            value={processingContent}
            onChange={(e) => setProcessingContent(e.target.value)}
            className='no-resize! rounded-lg bg-[#F7F8F6]'
            autoSize={{ minRows: 5, maxRows: 10 }}
          />
          <div className={'mt-3 flex justify-end space-x-4'}>
            <button
              onClick={() => {
                closeFeedback();
                setProcessingContent('');
              }}
              className='flex justify-end rounded-lg bg-[#D1131D] px-6 py-[10px] text-[16px]/[20px] font-semibold text-[#FFFFFF]'
            >
              Hủy
            </button>
            <button
              onClick={() => updateIntegrationAction()}
              className='flex justify-end rounded-lg bg-[#1564E8] px-6 py-[10px] text-[16px]/[20px] font-semibold text-[#FFFFFF]'
            >
              Xác nhận
            </button>
          </div>
        </Modal>
      </div>
    </Card>
  );
};

const Default_QaDetailMainInfor: QaDetailMainInfor = {
  id: 0,
  evaluator: '',
  evaluationDate: '',
  evaluationStatus: 0,
  recordingLink: '',
  videoLink: '',
  evaluationStatusDescription: '',
  completionDate: '',
  evaluationContent: '',
  feedbackContent: '',
  totalScore: 0,
  criteriaVersion: 0,
  totalDeductedScore: 0
};

const Default_QaIntegrationDetail: QaDetail = {
  id: 0,
  evaluator: '',
  evaluationDate: '',
  evaluationStatus: 0,
  recordingLink: '',
  videoLink: '',
  evaluationStatusDescription: '',
  completionDate: '',
  evaluationContent: '',
  feedbackContent: '',
  totalScore: 0,
  criteriaVersion: 0,
  totalDeductedScore: 0,
  criteriaData: [
    {
      id: 0,
      criteriaName: '',
      scoreList: [
        {
          ID: 0,
          criteriaID: 0,
          evaluationItemName: '',
          deductedScore: 0,
          version: 0
        }
      ],
      version: 0,
      versionName: '',
      totalScore: 0,
      level: 0,
      parentId: 0,
      hasChildren: 0
    }
  ],
  detailedEvaluationInfo: {
    0: 0
  }
};

export default QaIntegrationDetail;
